<template>
  <div>
    <div class="order-info">
      <el-checkbox
        class="check-box"
        v-model="checked"
        @change="infoCheck"
        v-if="type == 'store' || type == 'warehouse'"
      ></el-checkbox>

      <el-card shadow="hover" @click.native="details">
        <!--冰柜丢失报废 -->
        <el-row type="flex" align="middle" >
          <el-col :span="4" >
            <img v-if="info.coolerAsset.coolerImages.length" :src="getImageUrl(info.coolerAsset.coolerImages[0].coolerItemImageUri)" />
          </el-col>

          <el-col :span="9">
            <div class="trade-store-name margin-top-15">{{name}}</div>
            <div class="margin-top-15">{{ info.coolerAsset.coolerItemName }}</div>
            <div class="margin-top-15">{{ stateName }} 
              <span v-show="freezerStatus" :class="{'normal-hint':freezerStatus==='正常','hint':freezerStatus!=='正常'}">{{freezerStatus}}</span></div>
            <div class="margin-top-15">{{statusName}}: {{ info.coolerAsset.execTime| parseTime()}}</div>
          </el-col>
          
          <el-col :span="11" style="text-align: right;height:100%">
            <div class="margin-bottom-10">{{ info.coolerAsset.coolerAssetCode }}</div>
            <div class="margin-bottom-10 trade-store-number">{{address }}</div>
          </el-col>
        </el-row>

        <el-row type="flex" align="middle" v-if="type == 'warehouse'">
          <el-col :span="4">
            <img :src="getImageUrl(info.coolerAsset.coolerImages[0].coolerItemImageUri)" />
          </el-col>

          <el-col :span="9">
            <div class="trade-store-name margin-top-15">{{name}}</div>
            <div class="margin-top-15">{{ info.coolerAsset.coolerItemName }}</div>
            <div class="margin-top-15">{{ info.coolerAsset.coolerAssetStatusName }}</div>
          </el-col>

          <el-col :span="11" style="text-align: right;height:100%">
            <div class="margin-bottom-10">{{ info.coolerAsset.coolerAssetCode }}</div>
            <div class="margin-bottom-10 trade-store-number">{{address }}</div>
          </el-col>
        </el-row>

        <el-row type="flex" align="middle" v-if="type == 'all11'" >
          <el-col :span="4">
            <img :src="getImageUrl(info.coolerAsset.coolerImages[0].coolerItemImageUri)" />
          </el-col>

          <el-col :span="9">
            <div class="trade-store-name margin-top-15">{{name}}</div>
            <div class="margin-top-15">{{ info.coolerAsset.coolerItemName }}</div>
            <div class="margin-top-15">{{ info.coolerAsset.coolerAssetStatusName }}</div>
          </el-col>

          <el-col :span="11" style="text-align: right;height:100%">
            <div class="margin-bottom-10">{{ info.coolerAsset.coolerAssetCode }}</div>
            <div class="margin-bottom-10 trade-store-number">{{address }}</div>
          </el-col>

        </el-row>

        <el-row type="flex" align="middle" v-if="type == 'approve'">
          <el-col :span="4">
            <img :src="getImageUrl(info.coolerAsset.coolerImages[0].coolerItemImageUri)" />
          </el-col>

          <el-col :span="9">
            <div class="trade-store-name margin-top-15">{{name}}</div>
            <div class="margin-top-15">{{ info.coolerAsset.coolerItemName }}</div>
            <div class="margin-top-15">审批中</div>
          </el-col>

          <el-col :span="11" style="text-align: right;height:100%">
            <div class="margin-bottom-10">{{ info.coolerAsset.coolerAssetCode }}</div>
            <div class="margin-bottom-10 trade-store-number">{{address }}</div>
          </el-col>
        </el-row>

        <el-row type="flex" align="middle" v-if="type == 'lost'">
          <el-col :span="4">
            <img :src="getImageUrl(info.coolerAsset.coolerImages[0].coolerItemImageUri)" />
          </el-col>

          <el-col :span="9">
            <div class="trade-store-name margin-top-15">{{ info.coolerAsset.coolerItemName }}</div>

            <div class="margin-top-15">
              <span style="font-weight: bold;">{{title}}</span>
              {{ name }}
            </div>
            <div class="margin-top-15">
              <span style="font-weight: bold;">丢失时间</span>
              {{ info.coolerAsset.execTime | parseTime('{y}-{m}-{d}')}}
            </div>
             <div class="margin-top-15">
              <span style="font-weight: bold;">操作人</span>
              {{info.coolerAsset.updateUserName}}
            </div>
          </el-col>

          <el-col :span="11" style="text-align: right;height:100%">
            <div class="margin-bottom-10">{{ info.coolerAsset.coolerAssetCode }}</div>
            <div class="margin-bottom-10 trade-store-number">{{address }}</div>
          </el-col>
        </el-row>

        <el-row type="flex" align="middle" v-if="type == 'scrap'">
          <el-col :span="4">
            <img :src="getImageUrl(info.coolerAsset.coolerImages[0].coolerItemImageUri)" />
          </el-col>

          <el-col :span="9">
            <div class="trade-store-name margin-top-15">{{ info.coolerAsset.coolerItemName }}</div>
            <div class="margin-top-15">
              <span style="font-weight: bold;">{{title}}</span>
              {{ name }}
            </div>
            <div class="margin-top-15">
              <span style="font-weight: bold;">报废时间</span>
              {{ info.coolerAsset.execTime | parseTime('{y}-{m}-{d}')}}
            </div>
          </el-col>

          <el-col :span="11" style="text-align: right;height:100%">
            <div class="margin-bottom-10">{{ info.coolerAsset.coolerAssetCode }}</div>
            <div class="margin-bottom-10 trade-store-number">{{address }}</div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import { commonUtils } from "../../../utils/common";
import {localStorageUtils} from '@/utils/localstorage'
export default {
  name:'cooler-list-item',
  props: ["info", "type"],
  data() {
    return {
      typeList: [],
      checked: false, //是否选中
      obj: {}
    };
  },
  /* mounted(){
    console.log(this.info)
   }, */
  computed: {
    //投放类型
    stateName(){
      if(this.info.coolerAsset.execType==='21'
         ||this.info.coolerAsset.execType==='22'
         ||this.info.coolerAsset.execType==='23'){
         return this.info.coolerAsset.execTypeName
        }else if(this. info.coolerAsset.coolerAssetStatus==='5'
                 ||this.info.coolerAsset.coolerAssetStatus==='6'){
              return  '正常投放'
        }else{
          return this.info.coolerAsset.coolerAssetStatusName
        }
    },
    //冰柜当前状态
    statusName(){
      if(this.info.coolerAsset.coolerAssetStatus==='4')return '报废时间'
      if(this.info.coolerAsset.coolerAssetStatus==='3')return '丢失时间'
      if(this.info.coolerAsset.coolerAssetStatusName==='再投放审批中'
         ||this.info.coolerAsset.coolerAssetStatus==='2' )return '回库时间'
      // if(this.info.coolerAsset.coolerAssetStatusName==='正常投放'
      //    ||this.info.coolerAsset.coolerAssetStatusName==='转店审批中')return '投放时间'
     
      return '投放时间'
    },
    // 小状态
    freezerStatus(){
      let obj={
        '1':'正常',
        '5':'未插电',
        '6':'位移报警',
      }
      if(this.info.coolerAsset.execType==='21'
         ||this.info.coolerAsset.execType==='22'
         ||this.info.coolerAsset.execType==='23'){
          return ''
         }
      return obj[this.info.coolerAsset.coolerAssetStatus] ||''
    },
    name() {
      const { info = false } = this;
      if (!info) return "";
      if (info.pocInfo && info.pocInfo.pocName) {
        return info.pocInfo.pocName;
      }
      return info.wholesalerInfo.wholesalerName || "";
    },
    title() {
      const { info = false } = this;
      if (!info) return "";
      if (info.pocInfo && info.pocInfo.pocName) {
        if (this.type == "lost") {
          return "丢失门店";
        } else {
          return "报废门店";
        }
      }
      if (this.type == "scrap") {
        return "报废经销商";
      } else {
        return "丢失经销商";
      }
    },
    address() {
      const { info = false } = this;
      if (!info) return "";
      if (info.pocInfo && info.pocInfo.detailAddress) {
        return info.pocInfo.detailAddress;
      }
      return info.warehouseInfo.detailAddress || "";
    }
  },
  watch: {
    /* info: {
      immediate: true,
      deep: true,
      handler () {
        this.obj= Object.assign({},this,info)
      }
    } */
  },
  methods: {
    //点击查看详情
    details(){
     localStorageUtils.setWithExpire(`queryParams${this.type}`,JSON.stringify(this.$parent.queryParams))
      this.$router.push({
        name:'freezer-details',
        query:{
          id:this.info.coolerAsset.coolerAssetCode
        }
      })
    },
    //获取图片
    getImageUrl(url) {
      return commonUtils.getImageUrl(url);
    },

    //是否选中
    infoCheck() {
      let obj = {
        coolerAssetCode: this.info.coolerAsset.coolerAssetCode,
        checked: this.checked
      };
      if (this.info&&this.info.pocInfo?.pocId) {
        obj.pocId = this.info.pocInfo.pocId;
      } else {
        obj.wholesalerId = this.info.warehouseInfo.wholesalerId;
        obj.warehouseId = this.info.warehouseInfo.warehouseId;
      }
      this.$emit("infoCheck", obj);
    }
  }
};
</script>
<style lang="scss" scoped>
.hint{
  width: 60px;
  height: 16px;
  display: inline-block;
  line-height: 16px;
  text-align: center;
  color: #fff;
  background-color: #cd1231;
  border-radius: 4px;
  font-size: 12px;
}
.normal-hint{
  width: 60px;
  height: 16px;
  display: inline-block;
  line-height: 16px;
  text-align: center;
  color: #fff;
  background-color: #2ec947;
  border-radius: 4px;
  font-size: 12px;
}
.iten-right {
  display: flex;
  justify-items: center;
  align-items: center;
  flex-direction: column;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}
.order-info {
  position: relative;

  .el-card {
    border-radius: 8px;
  }
}
.check-box {
  position: absolute;
  top: 50%;
  left: -30px;
  transform: translateY(-50%);
  zoom: 140%;
}
.btn {
  height: 26px;
  padding: 0 15px;
  text-align: center;
  border-radius: 13px;
  line-height: 5px;
}
.batch-btn {
  margin-left: 45%;
  background-color: $base-white;
  color: $base-dark;
  border-color: $base-dark;
}
img,
.photo {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  object-fit: cover;
}
.trade-date {
  width: 100px;
  color: #666666;
  font-size: 14px;
  text-align: center;
  padding-top: 5px;
}
.order-info .el-button {
  margin-left: 0px;
  margin-right: 10px;
}

.btn-grey-plain {
  color: #888;
  border-color: #888;
}

.trade-store-name {
  font-size: 18px;
  font-weight: bold;
}
.trade-store-number {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    width: 20px;
    height: 20px;
    margin-left: 8px;
  }
}
</style>
